var _ellipse, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 113,
    viewBox: "0 0 163 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 173.02 42.9697)",
    fill: "#72A4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16340_89330)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 37,
    width: 89,
    height: 40,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 49C119.552 49 120 48.5523 120 48L120 44C120 43.4477 119.552 43 119 43L109 43C108.448 43 108 43.4477 108 44L108 48C108 48.5523 108.448 49 109 49L119 49Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 49C96.5523 49 97 48.5523 97 48L97 44C97 43.4477 96.5523 43 96 43L44 43C43.4477 43 43 43.4477 43 44L43 48C43 48.5523 43.4477 49 44 49L96 49Z",
    fill: "#C4D9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 63C119.552 63 120 62.5523 120 62L120 60C120 59.4477 119.552 59 119 59L44 59C43.4477 59 43 59.4477 43 60L43 62C43 62.5523 43.4477 63 44 63L119 63Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 71C82.5523 71 83 70.5523 83 70L83 68C83 67.4477 82.5523 67 82 67L44 67C43.4477 67 43 67.4477 43 68L43 70C43 70.5523 43.4477 71 44 71L82 71Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.25,
    y: 37.25,
    width: 88.5,
    height: 39.5,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16340_89330",
    x: 33,
    y: 37,
    width: 97,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16340_89330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16340_89330",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.ffcf9996.svg";
export { ForwardRef as ReactComponent };